import { NgClass } from '@angular/common';
import { Component, computed, inject, input, NgZone, output, viewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSelect, MatSelectChange, MatSelectModule } from '@angular/material/select';
import { SelectOption, SortPipe } from '@core';

@Component({
  imports: [NgClass, MatFormField, MatSelectModule, MatIcon, SortPipe],
  selector: 'app-multiple-select',
  standalone: true,
  templateUrl: './multiple-select.component.html',
})
export class MultipleSelectComponent {
  sortingEnabled = input(true);
  label = input('');
  selectClass = input('');
  panelClass = input('');
  showLabelPlaceholder = input(true);
  options = input<SelectOption[]>([]);
  showSelectedValues = input(true);
  selectDataEvent = output<string[]>();
  selectRef = viewChild<MatSelect>('selectRef');
  wrapper = viewChild<MatFormField>('wrapper');
  value = input<string[]>([]);
  selectElementClass = input('');
  protected cssPanelClass = computed(() => `multi-select-overlay ${this.panelClass()}`);
  protected labelDetails = computed(() => {
    const selectedValues = this.value();
    const separator = `${this.showLabelPlaceholder() ? ': ' : ''}`;
    let details = '';

    if (selectedValues?.length) {
      if (selectedValues.length === this.options().length) {
        details = `${separator}All`;
      } else {
        details = `${separator}${this.options()
          .find(option => option.value === selectedValues[0])?.title} ${selectedValues.length > 1 ? `(+${selectedValues.length - 1})` : ''
        }`;
      }
    }

    return details;
  });
  private ngZone = inject(NgZone);


  protected selectionChange(change: MatSelectChange) {
    this.selectDataEvent.emit(change.value);
    // this hack is needed to update position of the panel in case when layout changes after option select
    this.ngZone.runOutsideAngular(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  protected clearAll() {
    const select = this.selectRef();

    if (select) {
      select.value = [];
    }
    this.selectDataEvent.emit([]);
  }

  protected selectAll() {
    const allValues = this.options().map(option => option.value);

    const select = this.selectRef();

    if (select) {
      select.value = allValues;
    }
    this.selectDataEvent.emit(allValues);
  }
}
